<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="table"
      entity-name="category"
      :model="model"
      :use-delete-action="false"
      icon="mdi-label"
      style="width: 100%"
    >
      <template #item.action="{item}">
        <v-list-item
          @click="deleteCategory(item.id)"
        >
          <v-list-item-title>
            {{ $t('delete') }}
          </v-list-item-title>
        </v-list-item>
      </template>
      <template #footer="{tableItems}">
        <v-btn
          :small="$vuetify.breakpoint.mobile"
          :style="!$vuetify.breakpoint.mdAndUp ? '' : 'background: white !important'"
          elevation="0"
          outlined
          @click="setRandomColor(tableItems)"
        >
          <v-icon
            color="black"
            left
          >
            mdi-palette
          </v-icon>
          {{ $t('randomSetColor') }}
        </v-btn>
        <v-btn
          :small="$vuetify.breakpoint.mobile"
          :style="!$vuetify.breakpoint.mdAndUp ? '' : 'background: white !important'"
          elevation="0"
          outlined
          @click="startEditSort(tableItems)"
        >
          <v-icon
            color="black"
            left
          >
            mdi-file-edit
          </v-icon>
          {{ $t('editShowSort') }}
        </v-btn>
      </template>
    </ik-data-table>
    <nice-dialog
      v-model="showSortEdit"
    >
      <sort-fragment
        :initial-list="categoryList"
        :item-text="'_langsname'"
        item-sort="categorySort"
        @close="showSortEdit=false"
        @save="updateSort"
      />
    </nice-dialog>
    <v-dialog
      v-model="selectCategory"
      max-width="600px"
    >
      <v-card>
        <div class="d-flex align-center pa-4">
          <div class="text-h3 font-weight-bold">
            {{ $t('deleteThisCategory') }}
          </div>
        </div>
        <template v-if="!isLoading">
          <div class="pa-4">
            {{ $t('moveDishesToCategory', { dishesLength: dishesInCategory.length }) }}
          </div>
          <div class="pa-4">
            <v-item-group v-model="moveDishesCategory">
              <div
                style="display: grid;grid-template-columns: repeat(6,minmax(0,1fr));grid-gap: 8px"
              >
                <v-item
                  v-for="x in waitSelectedCategory"
                  :key="x.id"
                  v-slot="{ active, toggle }"
                >
                  <v-card
                    :color="x.color"
                    class="pa-2 d-flex align-center justify-center"
                    elevation="0"
                    outlined
                    @click="toggle()"
                  >
                    <v-responsive
                      :aspect-ratio="1"
                    >
                      <div
                        class="d-flex align-center justify-center flex-column"
                        style="height: 100%;position: relative"
                      >
                        <v-icon
                          v-if="active"
                          color="amber"
                          size="36"
                          style="position: absolute;bottom: 8px;right: 8px;"
                        >
                          mdi-check
                        </v-icon>
                        <div class="text-center text-body-1">
                          {{ x._langsname }}
                        </div>
                      </div>
                    </v-responsive>
                  </v-card>
                </v-item>
              </div>
            </v-item-group>
          </div>
          <div class="pa-4">
            <v-btn
              class=" mr-2"
              color="amber lighten-4 black--text"
              @click="moveDishAndDeleteCategory"
            >
              {{ $t('save') }}
            </v-btn>
            <v-btn
              outlined
              @click="selectCategory = false"
            >
              {{ $t('cancel') }}
            </v-btn>
          </div>
        </template>
        <template v-else>
          <div
            class="d-flex align-center justify-center"
            style="height: 400px"
          >
            <v-progress-circular
              indeterminate
              size="64"
            />
          </div>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import Category from '@/model/dataLayer/api/dish/Category'
import SortFragment from '@/views/AadenPages/dishes/dish/category/SortFragment'
import IKUtils from 'innerken-js-utils'
import NiceDialog from '@/views/widget/uiComponent/NiceDialog.vue'
import { showSuccessMessage } from '@/model/utils/utils'
import Dish from '@/model/dataLayer/api/dish/Dish'
import hillo from 'hillo'

export default {
  components: {
    NiceDialog,
    SortFragment,
    IkDataTable
  },
  data: function () {
    return ({
      chooseId: null,
      waitSelectedCategory: [],
      isLoading: true,
      moveDishesCategory: null,
      dishesInCategory: null,

      selectCategory: null,
      model: Category,
      categoryList: [],
      response: null,
      showSortEdit: false
    })
  },
  methods: {
    async moveDishAndDeleteCategory () {
      for (const item of this.dishesInCategory) {
        item.categoryId = this.waitSelectedCategory[this.moveDishesCategory].id
        await Dish.edit(item)
      }

      await hillo.post('Category.php?op=delete', { id: this.chooseId })
      this.selectCategory = false
      this.$refs.table.reload()
    },
    async deleteCategory (id) {
      this.chooseId = id
      this.isLoading = true
      this.selectCategory = true
      this.waitSelectedCategory = (await Category.getList(true)).filter(item => item.id !== id)
      this.dishesInCategory = (await Dish.getList(true)).filter(item => item.categoryId === id)
      if (this.dishesInCategory.length === 0) {
        this.selectCategory = false
        await hillo.post('Category.php?op=delete', { id })
        this.$refs.table.reload()
      }
      this.isLoading = false
    },
    async startEditSort (categoryList) {
      console.log(categoryList, 'list')
      this.categoryList = categoryList
      this.showSortEdit = true
    },
    async setRandomColor (categoryList) {
      this.model.randomColor(categoryList)
    },
    async updateSort (newList) {
      IKUtils.showLoading()
      const reqs = newList.map(async (it, i) => {
        it.categorySort = i + 1
        return await this.model.edit(it, false)
      })
      const res = await Promise.allSettled(reqs)
      console.log(res)
      this.showSortEdit = false
      this.$refs.table.reload()
      showSuccessMessage()
    }
  }
}
</script>
